import withHandlers from 'recompose/withHandlers';
import filter from 'lodash/fp/filter';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import {
  getActiveBarberId,
  getServiceSearch,
} from '../selectors';
import { addService } from '../../order/actions';
import { getSelectedServices } from '../../order/selectors';
import ServiceList from '../components/ServiceList';


const ServiceListContainer = compose(
  connect(
    (state, ownProps) => {
      const serviceSearch = getServiceSearch(state);
      const filterServices = filter((item) => {
        if (serviceSearch) return item.name.toLowerCase().includes(serviceSearch.toLowerCase());
        return true;
      });
      const activeBarberId = getActiveBarberId(state);
      return {
        services: filterServices(ownProps.services),
        selectedServices: getSelectedServices(state, activeBarberId),
        activeBarberId,
      };
    },
    { addService },
  ),
  withHandlers({
    addItem: props => id => props.addService(props.activeBarberId, id),
  })
)(ServiceList);

export default ServiceListContainer;
